import { CONTENT_ID_PAYLOAD, directLinks, HANDOFF_PAYLOAD, INITIAL_PAYLOAD, InitialContents, languages } from '../constants'

export type InitialPayloadParams = {
  queueId?: string
}

export function getInitialPayload(
  initialContent?: string,
  params?: InitialPayloadParams,
  language?: string
) {
  const { queueId } = params as InitialPayloadParams
  switch (initialContent) {
    case InitialContents.Advisor:
      return `${HANDOFF_PAYLOAD}|${JSON.stringify({ queueId })}`
    default:
      return language === languages.ENGLISH && directLinks[initialContent as InitialContents]
        ? `${CONTENT_ID_PAYLOAD}|${JSON.stringify({ contentId: directLinks[initialContent as InitialContents] })}`
        : INITIAL_PAYLOAD
  }
}
